Drupal.behaviors.sw_block_library_slider = {
  attach: function( context, settings ) {

    $('.library__slider').once('sw_block_library_slider').each(function() {
      let $wrap = $(this);
      let $slider = $wrap;
      $slider.slick({
        arrows: false,
        fade: false,
        dots: false,
        adaptiveHeight: false,
        infinite: false,
        centerMode: false,
        slidesToShow: 4,
        waitForAnimate: false,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 1,
              centerMode: true,
              arrows: true,
            }
          },
        ],
      });

    });

  }
};
